import React from 'react'
import ClientReportLibrary from '../../client/ClientReportLibrary'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3ClientReportLibraryPage() {
  return (
    <V3DataRouteShell>
      <ClientReportLibrary visualVariant="v3" />
    </V3DataRouteShell>
  )
}

